import React from 'react';
import Options from '../dashboard/partials/options';
import fakeAuth from '../../../fakeAuth';
import { Link } from 'react-router';
import Gear from '../../partials/gear';
import ScrollAnimation from 'react-animate-on-scroll';
import _ from 'lodash';
import request from 'superagent';
import config from '../../../config';
import { Popover, PopoverBody, PopoverHeader, } from 'reactstrap';
import { EditorState, convertToRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

class AddQA extends React.Component {
    state = {
        qa: null,
        microTransac: false,
        deleting: false
    }
    componentWillMount() {
        const { qas = [], qasActions, params } = this.props, { id } = params;
        if (id) {
            if (qas && qas.length && _.find(qas, a => parseInt(a.id, 10) === parseInt(id, 10))) {
                this.setState({ qa: _.find(qas, a => parseInt(a.id, 10) === parseInt(id, 10)) }, () => { this.setAnswer() })
            } else {
                this.setState({ microTransac: true }, () => {
                    qasActions && qasActions.fetch(id);
                });
            }
        } else {
            this.setState({ qa: {} }, () => { this.setAnswer() });
        }
    }
    componentWillReceiveProps = nextProps => {
        const { qa } = nextProps;
        this.setState({ qa, microTransac: false }, () => {
            this.setAnswer();
        });
    }

    setAnswer = () => {
        const { qa = {} } = this.state;
        if (qa) {
            if (qa.Answer && qa.Answer.length) {
                const contentBlock = htmlToDraft(qa.Answer);
                if (contentBlock) {
                    const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
                    const editorState = EditorState.createWithContent(contentState);
                    this.setState({ editorState });
                }
            } else {
                this.setState({ editorState: EditorState.createEmpty() });
            }
        }
    }
    logout = () => {
        fakeAuth.signout(() => {
            this.props.router.push('/admin');
        });
    }
    save = () => {
        const { qa, editorState } = this.state, { qasActions } = this.props;
        qa.Question = this.txtQuestion.value;
        qa.Answer = draftToHtml(convertToRaw(editorState.getCurrentContent()));

        this.setState({ microTransac: true }, () => {
            request[qa.id ? 'patch' : 'post'](`${config.apiEndpoint}/api/cs/v2/qas${qa.id ? `/${qa.id}` : ''}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .send(qa)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        qasActions.fetch();
                        this.props.router.push('/admin/qas');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    toggleDelete = () => this.setState({ deleting: !this.state.deleting });
    doDelete = () => {
        const { qa } = this.state, { qasActions } = this.props;
        this.setState({ microTransac: true }, () => {

            request.del(`${config.apiEndpoint}/api/cs/v2/qas/${qa.id}`)
                .set('Authorization', `Bearer ${config.apiKey}`)
                .then((data) => {
                    // TODO: Handle any kind of error here
                    if (data.body.success) {
                        qasActions.fetch();
                        this.props.router.push('/admin/qas');
                    } else {
                        alert('ERROR')
                        console.log(data.body);
                        this.setState({ microTransac: false });
                    }
                });
        });
    }
    toggleCategories = () => this.setState({ isCategoriesOpen: !this.state.isCategoriesOpen });
    selectQACategory = (category) => {
        const { qa } = this.state;
        qa.IdCategory = category.value;
        this.setState({ qa, isCategoriesOpen: false });
    }
    onEditorStateChange = (editorState) => this.setState({ editorState });

    render() {
        const { qa = {}, microTransac, editorState, } = this.state, { qasCategories } = this.props;
        return (
            <section className="d-flex flex-column h-100">
                <div className="d-flex flex-row p-4">
                    <Link to="/admin/qas" className="align-self-center idented d-flex flex-row white font-16">
                        <i className="fas fa-arrow-left margin-right align-self-center" />
                        <span className="anton align-self-center">BACK</span>
                    </Link>
                    {microTransac && <Gear className="ml-auto" />}
                    <h1 className="anton ml-auto align-self-center no-margin no-padding text-right white padding-right">Q{'&'}S | ADD</h1>
                </div>
                <div className="h-100" style={{ position: 'relative' }}>
                    <section id="left" style={{ position: "absolute", top: 0, bottom: 0, left: 0, width: 200 }} className="">
                        <Options current={4} onLogout={this.logout} animated={false} />
                    </section>
                    <section id="left" style={{ position: "absolute", overflowY: 'auto', top: 0, bottom: 0, left: 200, right: 0 }} className="clearfix padding-right">
                        {qa &&
                            <ScrollAnimation animateIn="fadeInRight" animateOnce={true}>
                                <figure className="card w-100 p-4">
                                    <div className="d-flex flex-row">
                                        <div className="w-100">
                                            <label htmlFor="name" className="block">Question</label>
                                            <input className="block w-100" type="text" required ref={(i) => this.txtQuestion = i} defaultValue={qa.Question} />
                                        </div>
                                        <div style={{ width: 20 }} />
                                        <div>
                                            <label htmlFor="name">Category</label>
                                            <div className="btn-group block">
                                                <button type="button" onClick={this.toggleCategories} className="btn btn-sm btn-info dropdown-toggle w-100 text-left" data-toggle="dropdown">{qa.IdCategory ? (_.find(qasCategories, af => af.value === qa.IdCategory) || {}).name : 'Please select'}</button>
                                                <div className={`dropdown-menu ${this.state.isCategoriesOpen ? 'show' : ''}`}>
                                                    {qasCategories && qasCategories.map((category, index) => <a key={index} onClick={() => this.selectQACategory(category)} className="dropdown-item">{category.name}</a>)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <label htmlFor="name" className="margin-top">Answer</label>

                                    <figure className="w3-card pt-2 pb-2 pl-4 pr-4">
                                        <Editor
                                            ref={(i) => this.txtAnswer = i}
                                            editorState={editorState}
                                            toolbarClassName="toolbarClassName"
                                            wrapperClassName="wrapperClassName"
                                            editorClassName="editorClassName"
                                            onEditorStateChange={this.onEditorStateChange}
                                            toolbar={{
                                                options: ['inline', 'blockType', 'fontSize', 'fontFamily', 'list', 'textAlign'],
                                                inline: { inDropdown: false },
                                                list: { inDropdown: true },
                                                textAlign: { inDropdown: false },
                                                fontFamily: { options: ['Hind', 'Anton'] },
                                            }}
                                        />
                                    </figure>
                                    <div className="d-flex flex-row margin-top">
                                        {qa.id && <button id="btn-delete" onClick={this.toggleDelete} type="button" style={{ width: 100 }} className="align-self-center btn-red text-center">REMOVE</button>}
                                        <Link to="/admin/qas" className="align-self-center btn-link text-center ml-auto margin-right black">CANCEL</Link>
                                        <button onClick={this.save} type="submit" style={{ width: 100 }} className="align-self-center btn-white text-center">SAVE</button>
                                    </div>
                                    {qa.id && <Popover placement="bottom" isOpen={this.state.deleting} target={`btn-delete`} toggle={this.toggleDelete}>
                                        <PopoverHeader>Are you sure?</PopoverHeader>
                                        <PopoverBody className="d-flex flex-row justify-content-center">
                                            <button className="btn btn-success btn-sm" onClick={this.doDelete}>Yes, Delete it</button>
                                            <button className="btn btn-danger btn-sm" onClick={this.toggleDelete}>No, Cancel</button>
                                        </PopoverBody>
                                    </Popover>}
                                </figure>
                            </ScrollAnimation>}
                    </section>
                </div>
            </section>
        )
    }
}

export default AddQA;



// WEBPACK FOOTER //
// ./src/components/private/qas/add.js